import React from 'react';
import styles from "./AgentChatBubble.module.css"
import { ChatMessage } from '../CustomerServiceSection';
import AssetsPack from '../../../../../util/AssetsPack';
import { useTranslation } from "react-i18next";

interface AgentChatBubbleProps extends React.HTMLAttributes<HTMLDivElement> {
    data: ChatMessage
}

const AgentChatBubble: React.FC<AgentChatBubbleProps> = ({
    data
}) => {
    const { t } = useTranslation();

    const ICONS_MAP = {
        ["BOT"]: AssetsPack.icons.ICON_CUSTOMER_SUPPORT.default,
        ["USER"]: AssetsPack.icons.ICON_CUSTOMER.default,
    };

    const USER_NAME_MAP = {
        USER: t("chatDialog.jokerUser"),
        BOT: t("chatDialog.customer_service"),
    }

    const { content, sender } = data;

    const key = sender.toUpperCase() as 'USER' | 'BOT';

    return (
        <div className={`${styles.container} ${styles[key.toLowerCase() as 'user' | 'bot']}`}>
            <img
                className={styles["chat-image"]}
                src={ICONS_MAP[key]}
                alt={`${key.toLowerCase()}-icon`}
            />
            <div className={styles["chat-content"]}>
                <div className={styles["chat-username"]}>
                    {USER_NAME_MAP[key]}
                </div>
                <div className={styles["chat-text"]}>
                    {content}
                </div>
                {data.image_urls?.map((url) => {
                    return <img
                        className={styles["attachment-image"]}
                        src={url}
                        alt={`${key.toLowerCase()}-icon`}
                    />
                })}
            </div>
        </div>
    );
};

export default AgentChatBubble;